import React, { type FC, useEffect } from "react";

import { IconLoadingOutlined, IconSearchOutlined } from "~/components/icon";
import { cx } from "~/tools/class-variance";

import { Input } from "./Input";

export const SearchInput: FC<{
	className?: string;
	value: string;
	isFetching: boolean;
	placeholder?: string;
	onSearch: (filter: string) => void;
}> = ({ className, value, placeholder = "Search", onSearch, isFetching }) => {
	const [filter, setFilter] = React.useState(value);

	useEffect(() => {
		setFilter(value);
	}, [value]);

	return (
		<Input
			allowClear={true}
			className={cx("w-[280px]", className)}
			data-testid="search-input"
			onChange={(next) => {
				setFilter(next);
				onSearch(next);
			}}
			onConfirm={onSearch}
			placeholder={placeholder}
			prefix={
				isFetching ? (
					<IconLoadingOutlined className="pr-1 text-gray-800" />
				) : (
					<IconSearchOutlined className="pr-1 text-gray-800" />
				)
			}
			value={filter}
		/>
	);
};
